import { render, staticRenderFns } from "./search_local_main.vue?vue&type=template&id=fdadb194&scoped=true&"
import script from "./search_local_main.vue?vue&type=script&lang=js&"
export * from "./search_local_main.vue?vue&type=script&lang=js&"
import style1 from "./search_local_main.vue?vue&type=style&index=1&id=fdadb194&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdadb194",
  null
  
)

export default component.exports